<template>
  <div class="tab-nav">
    <div v-for="tab in visibleTabs" :key="tab" class="tab-item" :class="{ active: modelValue === tab }"
      @click="handleTabClick(tab)">
      {{ tab }}
    </div>
  </div>
</template>

<script setup>
import { computed, reactive, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import useAppStore from '@/store/modules/app'
import useUserStore from '@/store/modules/user'
import { useRoute } from 'vue-router'
import { DATA_ANALYSIS_MENU_PERMS } from '@/config/menuPermissionGroups'
const appStore = useAppStore()
const userStore = useUserStore()
const { permissions } = storeToRefs(userStore)

const route = useRoute()

const props = defineProps({
  modelValue: {
    type: String,
    default: '实时监控'
  },
  tabs: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['update:modelValue'])
const stationId = computed(() => route.query.stationId)
const station = computed(() => appStore.getStationById(stationId.value))
const tabPerms = {
  '主监控': ['device:realtime:query'],
  '电站拓扑': ['device:topology:query'],
  '储能系统': ['device:storage:query'],
  '充放记录': ['device:chargeRecord:query'],
  '电表': ['device:meter:query'],
  '光伏': ['device:pv:query'],
  '收益总览': ['operate:revenue:query'],
  '电价录入': ['operate:electricPrice:query'],
  '抄表结算': ['operate:meterSettle:query'],
  '电表读数': ['operate:meterReading:query'],
  '电价维护': ['operate:electricPriceMaintain:query'],
  '远程电表': ['operate:remoteMeter:query'],
  '策略控制': ['ops:strategy:query'],
  '策略模板': ['ops:strategy:module:query'],
  '高级配置': ['ops:strategy:set:query'],
  '告警管理': ['ops:alarm:query'],
  '智能告警': ['ops:smartAlert:query'],
  '告警信息': ['ops:alarmInfo:query'],
  '远程开关机': ['ops:params:set'],
  '数据分析': DATA_ANALYSIS_MENU_PERMS,
}

function hasPerms(perms) {
  if (!Array.isArray(perms) || !perms.length) return true
  return (permissions.value || []).some(permission => permission === '*:*:*' || perms.includes(permission))
}

// 根据电站信息动态控制标签页显示
const visibles = computed(() => {
  return {
    '光伏': !!(station.value?.pvAccess * 1)
  }
})

// 根据 visibles 计算最终显示的标签页列表
const visibleTabs = computed(() => {
  return props.tabs.filter(tab => {
    const tabVisible = visibles.value[tab]
    return (tabVisible === void 0 || tabVisible) && hasPerms(tabPerms[tab])
  })
})

// Tab变化时对当前选中的Tab进行切换
watch(visibleTabs, (newValue) => {
  if (newValue.length > 0 && !newValue.includes(props.modelValue)) {
    emit('update:modelValue', newValue[0])
  }
}, { immediate: true, flush: 'post' })

const handleTabClick = (tab) => {
  emit('update:modelValue', tab)
}
</script>

<style scoped lang="scss">
.tab-nav {
  display: flex;
  align-items: center;
  gap: 40px;
}

.tab-item {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 300;
  line-height: normal;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.3s ease;

  &:hover {
    color: rgba(46, 46, 46, 0.8);
  }

  &.active {
    // color: rgba(46, 46, 46, 1);
    color: var(--color-primary);
    font-weight: 400;
  }
}
</style>
